import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useSignOut () {
  return useQuery('sign-out', async () => {
    const response = await axios.get(`${getApiServer()}/signout`, { withCredentials: true })
    return response.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}